/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePurchaseInvoiceEstimateItemDto
 */
export interface CreateUpdatePurchaseInvoiceEstimateItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoiceEstimateItemDto
     */
    estimateItemId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoiceEstimateItemDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePurchaseInvoiceEstimateItemDto
     */
    projectId?: string;
}

/**
 * Check if a given object implements the CreateUpdatePurchaseInvoiceEstimateItemDto interface.
 */
export function instanceOfCreateUpdatePurchaseInvoiceEstimateItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimateItemId" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function CreateUpdatePurchaseInvoiceEstimateItemDtoFromJSON(json: any): CreateUpdatePurchaseInvoiceEstimateItemDto {
    return CreateUpdatePurchaseInvoiceEstimateItemDtoFromJSONTyped(json, false);
}

export function CreateUpdatePurchaseInvoiceEstimateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePurchaseInvoiceEstimateItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'estimateItemId': json['estimateItemId'],
        'amount': json['amount'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}

export function CreateUpdatePurchaseInvoiceEstimateItemDtoToJSON(value?: CreateUpdatePurchaseInvoiceEstimateItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estimateItemId': value.estimateItemId,
        'amount': value.amount,
        'projectId': value.projectId,
    };
}

